/** Dependencies tab: the LIVE dep-editor Gantt (SequenceView) in read-only mode,
 *  rendered straight from the snapshot's frozen dep_graph — same bars, driving
 *  lines, arrows and grouping as the live editor, with every edit affordance
 *  gated off by readOnly. */
import React from "react";
import type { PullPlanSnapshot } from "../../../../models";
import SequenceView from "../../SequenceView/SequenceView";
import type { DepEditIntents } from "../../depCore/DepTable/DepTable";
import "./DependenciesTab.css";

const NOOP_INTENTS: DepEditIntents = {
  onAddEdge: () => {},
  onRemoveEdge: () => {},
  onRetypeEdge: () => {},
};
const noop = () => {};

const DependenciesTab: React.FC<{ snapshot: PullPlanSnapshot }> = ({ snapshot }) => (
  <div className="cpv-deps">
    <SequenceView
      variant="plan"
      graph={snapshot.dep_graph}
      loading={false}
      error={null}
      readOnly
      intents={NOOP_INTENTS}
      onEditDuration={noop}
      onApplyEdit={noop}
      onRequestDelete={noop}
    />
  </div>
);

export default DependenciesTab;
